import { Heading } from '@boltenergy-be/design-system'
import CollapsibleCard from 'components/collapsible-card/CollapsibleCard'
import { ContractDetailsProps } from '../types'
import styles from '../Details.module.scss'
import { useTranslation } from 'react-i18next'
import DataBlock from 'features/contracts/add/components/data-block/DataBlock'
import MappedContractStatus from 'pages/sales/details/components/mapped-contract-status/MappedContractStatus.tsx'
import { ENERGY_TYPES, EnergyType } from '@boltenergy-be/shared'

const ContractDetails = <ET extends EnergyType>({ contract }: ContractDetailsProps<ET>) => {
  // i18n
  const { t } = useTranslation(['sales', 'common'])

  return (
    <CollapsibleCard
      titleSection={
        <Heading as="h2" variant="h4" className={styles.title}>
          {t(($) => $.details.contract.title)}{' '}
          {t(($) => $[contract.detail.energyType === ENERGY_TYPES.gas ? 'gas' : 'electricity'], { ns: 'common' }).toLowerCase()}
        </Heading>
      }
      contentClassName={styles['details-block']}
    >
      <DataBlock label={t(($) => $.details.contract.status)}>
        <MappedContractStatus status={contract.detail.status} />
      </DataBlock>
      <DataBlock label={t(($) => $.details.contract.registrationDate)}>{contract.detail.subscriptionDate}</DataBlock>
      <DataBlock label={t(($) => $.details.contract.startDate)}>{contract.detail.contractualStartDate}</DataBlock>
      <DataBlock label={t(($) => $.details.contract.endDate)}>{contract.detail.effectiveEndDate}</DataBlock>
    </CollapsibleCard>
  )
}

export default ContractDetails
